import React, { useEffect, useState } from "react";
import TableHeading from "../../components/common/TableHeading";
import { RIGHTARROW_ICON } from "../../../utills/image-constant";
import Inputwithlable from "../../components/common/inputwithlable";
import DropDownWithLabel from "../../components/common/DropDownWithlable";
import { ROUTES } from "../../routes/url-constant";
import { useLocation, useNavigate } from "react-router-dom";
import { AddCriteriaAdmin, getAllDimensionByModelId, getAllModels, getAllSubDimensionById } from "../../../services/api-services";
import Loginbtn from "../../components/common/loginbtn";
import { toastEmitter } from "../../../utills/utilities";
import { API_RESPONSE } from "../../../utills/app-constant";

const AddCriteria = () => {
  const navigate = useNavigate();
  const location = useLocation();
  let CriteriaData = location?.state?.Data;
  let Criteriatype = location?.state?.pageType;

  const [modelList, setModelList] = useState([]);
  const [dimensionList, setDimensionList] = useState([]);
  const [subDimensionList, setSubDimensionList] = useState([]);

  const [criteria, setCriteria] = useState({
    criteriaShortLabel: "",
    criteriaDescription: "",
    modelfk: "",
    dimensionfk: "",
    subDimensionfk: "",
    optionList: Array.from({ length: 5 }, (_, index) => ({
      levelNumber: index + 1,
      value: ["Initiating", "Emerging", "Performing", "Advancing", "Leading"][index] || "",
      description: "",
    })),
  });


  const getListOfModel = async (val) => {
    try {
      const response = await getAllModels(val);
      if (response?.data?.responseCode === 200) {
        const modelOptions = response?.data?.responseBody?.map((model) => ({
          value: model.id,
          label: model.modelName,
          Status: model.status,
        }));
        setModelList(modelOptions);
      }
    } catch (err) {
      console.error("Error fetching models", err);
    }
  };

  useEffect(() => {
    getListOfModel(1);
  }, []);

  const getListOfDimension = async (id, val) => {
    try {
      const response = await getAllDimensionByModelId(id, val);
      if (response?.data?.responseCode === 200) {
        const modelOptions = response?.data?.responseBody?.map((model) => ({
          value: model.id,
          label: model.dimensionName,
          Status: model.status,
        }));
        setDimensionList(modelOptions);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getListOfsubDimension = async (id, val) => {
    try {
      const response = await getAllSubDimensionById(id, val);
      if (response?.data?.responseCode === 200) {
        const subDimensionOptions = response?.data?.responseBody?.map((model) => ({
          value: model.id,
          label: model.subDimensionName,
          Status: model.status,
        }));
        setSubDimensionList(subDimensionOptions);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const prefillData = async () => {
      await getListOfModel(0);
      if (Criteriatype === "Edit" && CriteriaData) {
        if (CriteriaData.modelResponse?.id) await getListOfDimension(CriteriaData.modelResponse.id, 0);
        if (CriteriaData.dimensionResponse?.id) await getListOfsubDimension(CriteriaData.dimensionResponse.id, 0);
        setCriteria({
          id: CriteriaData.id || "",
          criteriaShortLabel: CriteriaData.criteriaShortLabel || "",
          criteriaDescription: CriteriaData.criteriaDescription || "",
          modelfk: CriteriaData.modelResponse?.id || "",
          dimensionfk: CriteriaData.dimensionResponse?.id || "",
          subDimensionfk: CriteriaData.subDimensionResponse?.id || "",
          enable: CriteriaData.modelResponse.enable,
          enable: CriteriaData.dimensionResponse.enable,
          enable: CriteriaData.subDimensionResponse.enable,
          optionList: CriteriaData.optionResponseList?.map((option, index) => ({
            levelNumber: option.levelNumber || index + 1,
            value: option.value || "",
            description: option.description || "",
          })) || [],
        });
      }
      if (Criteriatype === "view" && CriteriaData) {
        if (CriteriaData.modelResponse?.id) await getListOfDimension(CriteriaData.modelResponse.id, 0);
        if (CriteriaData.dimensionResponse?.id) await getListOfsubDimension(CriteriaData.dimensionResponse.id, 0);
        setCriteria({
          id: CriteriaData.id || "",
          criteriaShortLabel: CriteriaData.criteriaShortLabel || "",
          criteriaDescription: CriteriaData.criteriaDescription || "",
          modelfk: CriteriaData.modelResponse?.id || "",
          dimensionfk: CriteriaData.dimensionResponse?.id || "",
          subDimensionfk: CriteriaData.subDimensionResponse?.id || "",
          enable: CriteriaData.modelResponse.enable,
          enable: CriteriaData.dimensionResponse.enable,
          enable: CriteriaData.subDimensionResponse.enable,
          optionList: CriteriaData.optionResponseList?.map((option, index) => ({
            levelNumber: option.levelNumber || index + 1,
            value: option.value || "",
            description: option.description || "",
          })) || [],
        });
      }
    };

    prefillData();
  }, [CriteriaData, Criteriatype]);

  const handleChange = (event) => {
    setCriteria({ ...criteria, [event.target.name]: event.target.value });
  };

  const handleOptionChange = (index, field, value) => {
    const updatedOptions = [...criteria.optionList];
    updatedOptions[index][field] = value;
    setCriteria((prevState) => ({
      ...prevState,
      optionList: updatedOptions,
    }));
  };

  const handleSelectValue = (event) => {
    const { name, value } = event.target;
    if (value === "") {
      setDimensionList([])
      setSubDimensionList([])
      setCriteria({ ...criteria, modelfk: "", dimensionfk: "", subDimensionfk: "" })
    }
    if (name === "modelfk") {
      getListOfDimension(value, 1);
      setSubDimensionList([])
    } else if (name === "dimensionfk") {
      getListOfsubDimension(value, 1)
    }
    setCriteria({ ...criteria, [name]: value });
  };

  const handleNavigateBack = () => {
    navigate(ROUTES.CRITERIATABLE);
  };

  const validateForm = () => {
    const { criteriaShortLabel, criteriaDescription, modelfk, dimensionfk, subDimensionfk, optionList } = criteria;
    if (!criteriaShortLabel || !criteriaDescription || !modelfk || !dimensionfk || !subDimensionfk) {
      toastEmitter("error", "All main fields are mandatory.");
      return false;
    }

    for (let i = 0; i < optionList.length; i++) {
      const { value, levelNumber, description } = optionList[i];
      if (!value || !levelNumber || !description) {
        toastEmitter("error", `All fields for Level ${i + 1} are mandatory.`);
        return false;
      }
    }
    return true;
  };

  const handleAddCriteria = async () => {
    if (validateForm()) {
      try {
        const response = await AddCriteriaAdmin(criteria);
        if (response?.data?.responseCode !== 200) {
          toastEmitter("error", response?.data?.message);
        }
        if (response.data?.responseCode === 200) {
          toastEmitter("success", response?.data?.message);
          navigate(ROUTES.CRITERIATABLE);
        }
      } catch (err) {
        toastEmitter("error", API_RESPONSE.MESSAGE_503);
      }
    }
  }

  return (
    <>
      <TableHeading
        secondclassName="cursor-pointer"
        firstData="Assessment Modeling"
        icon={RIGHTARROW_ICON}
        secondData="Criteria Management"
        iconshow={true}
        thirdData={Criteriatype == "Edit" ? "Update Criteria" : Criteriatype === "view" ? "View Criteria" : "Add Criteria"}
        onFirstDataClick={handleNavigateBack}
      />
      <div className="container-fluid">
        <div className="caspera_employee_add">
          <div className="row">
            <div className="col-md-4">
              <DropDownWithLabel
                name="modelfk"
                labelName="Select Maturity Model"
                options={modelList}
                value={criteria.modelfk}
                showastrict={true}
                handleSelect={handleSelectValue}
                className="addInputText-lable"
                lableclassName="addInput-label"
                disabled={Criteriatype === "view" || criteria?.enable === false}
                message={criteria?.enable === false ? "This criteria already exists ,and the model cannot be modified" : ""}

              />
            </div>
            <div className="col-md-4">
              <DropDownWithLabel
                name="dimensionfk"
                labelName="Select Dimension"
                options={dimensionList}
                value={criteria?.dimensionfk}
                handleSelect={handleSelectValue}
                className="addInputText-lable"
                lableclassName="addInput-label"
                showastrict={true}
                disabled={Criteriatype === "view" || criteria?.enable === false}
                message={criteria?.enable === false ? "This criteria already exists ,and the dimention cannot be modified" : ""}
              />
            </div>
            <div className="col-md-4">
              <DropDownWithLabel
                name="subDimensionfk"
                labelName="Select Sub-Dimension"
                options={subDimensionList}
                value={criteria?.subDimensionfk}
                handleSelect={handleSelectValue}
                className="addInputText-lable"
                showastrict={true}
                lableclassName="addInput-label"
                disabled={Criteriatype === "view" || criteria?.enable === false}
                message={criteria?.enable === false ? "This criteria already exists ,and the subdimention cannot be modified" : ""}

              />
            </div>
            <div className="col-md-12">
              <Inputwithlable
                placeHolder="Enter Short Label"
                name="criteriaShortLabel"
                type="text"
                labelName="Criteria Short Label"
                lableclassName="addInput-label"
                className="form-control addInputText-lable"
                handleChange={handleChange}
                showastrict={true}
                value={criteria.criteriaShortLabel}
                maxlng={64}
                disable={Criteriatype === "view"}
                readOnly={Criteriatype === "view"}
              />
            </div>
            <div className="col-md-12">
              <Inputwithlable
                placeHolder="Enter Question"
                name="criteriaDescription"
                type="text"
                labelName="Criteria Description (Question)"
                lableclassName="addInput-label"
                className="form-control addInputText-lable"
                handleChange={handleChange}
                showastrict={true}
                value={criteria.criteriaDescription}
                disable={Criteriatype === "view"}
              />
            </div>
          </div>

          <div className="mt-4">
            <h5>Criteria Options</h5>
            {criteria.optionList.map((option, index) => (
              <div key={index} className="criteria_levels_content p-4 px-2 mb-3">
                <div className="container-fluid">
                  <div className="row">
                    <h5>Level {option.levelNumber}</h5>
                    <div className="col-md-12">
                      <Inputwithlable
                        placeHolder="Enter Value"
                        name={`value_${index}`}
                        type="text"
                        labelName="Level Value"
                        showastrict={true}
                        lableclassName="input-label"
                        className="form-control inputText-lable"
                        handleCha nge={(e) => handleOptionChange(index, "value", e.target.value)}
                        value={option.value}
                        disable={Criteriatype === "view" || true}
                      />
                    </div>
                    <div className="col-md-12">
                      <Inputwithlable
                        placeHolder="Enter Description"
                        name={`description_${index}`}
                        type="text"
                        labelName="Level Description"
                        showastrict={true}
                        lableclassName="input-label"
                        className="form-control inputText-lable"
                        handleChange={(e) => handleOptionChange(index, "description", e.target.value)}
                        value={option.description}
                        disable={Criteriatype === "view"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="pt-2 d-flex justify-content-center">
            {Criteriatype === "view" ? "" : <Loginbtn
              className="addbtn w-100 px-4 py-2"
              handleClick={handleAddCriteria}
              type="submit"
              btnName={Criteriatype == "Edit" ? "Update" : "ADD"}
            />
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCriteria;
